import { Rank, RANK_LABELS } from '@/types';
import { cn } from '@/lib/utils';
import { Trophy, Star, Crown, Gem, Sparkles, Flame } from 'lucide-react';

interface RankBadgeProps {
  rank: Rank;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}

const rankIcons: Record<Rank, React.ReactNode> = {
  bronze: <Trophy className="w-3 h-3" />,
  silver: <Star className="w-3 h-3" />,
  gold: <Crown className="w-3 h-3" />,
  platinum: <Gem className="w-3 h-3" />,
  diamond: <Sparkles className="w-3 h-3" />,
  master: <Flame className="w-3 h-3" />,
};

const sizeClasses = {
  sm: 'text-[10px] px-2 py-0.5',
  md: 'text-xs px-3 py-1',
  lg: 'text-sm px-4 py-1.5',
};

export function RankBadge({ rank, size = 'md', showLabel = true, className }: RankBadgeProps) {
  const isEliteRank = rank === 'diamond' || rank === 'master';
  
  return (
    <div
      className={cn(
        'rank-badge inline-flex items-center gap-1.5',
        `rank-${rank}`,
        sizeClasses[size],
        isEliteRank && `rank-badge-${rank}`,
        className
      )}
    >
      {rankIcons[rank]}
      {showLabel && <span>{RANK_LABELS[rank]}</span>}
    </div>
  );
}
